import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils'; // Utility function to extract date parts

import { FaUserCircle } from 'react-icons/fa'; // Importing icons
import { Link } from 'react-router-dom'; // Importing Link for navigation


const Blog = ({ blog }) => {

  const { id, image, date, heading, admin, category } = blog; // Extracting data from blog
  const { day, fullMonth, year } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (
    <div className='blog-item' key={id}>

      {/* Blog image */}
      <img src={image} alt={heading} />

      {/* Date section */}
      <div className="date">
        <span>{day}</span> 
        <h5>{fullMonth}, {year} </h5>
      </div>

      <div className='content'>

        {/* Blog title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading}
        </Link>

        {/* Blog details section */}
        <div className='details'>

          {/* Admin information with icon */}
          <h3>
            <div className='icon'><FaUserCircle /></div>
            <span>By {admin}</span>
          </h3>

          {/* Blog category with navigation link */}
          <Link className='category label' to={`/Blogs/category/${category}`}>
            {category}
          </Link>

        </div>
      </div>
    </div>
  );
};

export default Blog;